﻿﻿export interface IMoveTrackerNotesRequest {
    donorId: number;
    notes: string;
}
